import { domainEndpoint } from '@/api/axios';
import useHashParams from '@/composables/general/useHashParams';
import { calendarStore } from '@/store/calendar-store';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import deLocale from '@fullcalendar/core/locales/de';
import { RouteLocationNormalized } from 'vue-router';

export default function useCalendar(route: RouteLocationNormalized) {
  const { setHashParams } = useHashParams(route);

  function initCalendar(calendarElement: HTMLElement, config: any) {
    let height = 'auto';
    if (config.parent_height) {
      height = '100%';
    }
    let base_url = process.env.VUE_APP_SERVER_BASE_URL;
    if (base_url == '/') {
      base_url = window.location.protocol + '//' + window.location.host;
    }
    return new Calendar(calendarElement, {
      plugins: [dayGridPlugin, interactionPlugin, listPlugin],
      themeSystem: 'bootstrap',
      eventSources: [
        {
          url: base_url + '/api/v1/' + domainEndpoint() + '/calendar_entry/fullcalendar',
          extraParams: { src: 'widgets' },
        },
      ],
      locales: [deLocale],
      locale: 'de',
      eventDisplay: 'auto',
      eventTimeFormat: { hour: '2-digit', minute: '2-digit' },
      lazyFetching: true,
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,listMonth',
      },
      buttonText: {
        today: 'Heute',
        dayGridMonth: 'Monatsansicht',
        listMonth: 'Listenansicht',
      },
      initialView: config.initialView,
      height: height,
      eventClassNames: function (arg) {
        const attributes: Array<string> = [];
        arg.event.classNames.forEach((attr: any) => attributes.push(attr.value));
        return attributes;
      },
      eventClick: info => {
        info.jsEvent.preventDefault(); // don't let the browser navigate
        //NOTE:
        //getSingleEvent() gets called through query-watcher in Calendar.vue
        setHashParams({ cal_eventid: info.event.id });
        calendarStore.showEventDetail(true);
      },
    });
  }

  return {
    initCalendar,
  };
}
